import useDidUpdateEffect from "@hooks/useDidUpdateEffect";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

// Component listens for changes of starting country or destination country fields
// and reloads package sizes depending on new values

const usePackageSizesLoader = (): void => {
  const { values } = useOrderFormik();

  const { updatePackageSizes } = useOrderData();

  const startingCountry = values[OrderFields.STARTING_COUNTRY] || undefined;
  const destinationCountry = values[OrderFields.DESTINATION_COUNTRY] || undefined;
  const deliveryMethod = values[OrderFields.DELIVERY_METHOD] || undefined;

  useDidUpdateEffect(() => {
    updatePackageSizes(startingCountry, destinationCountry, deliveryMethod);
  }, [startingCountry, destinationCountry, updatePackageSizes, deliveryMethod]);
};
export default usePackageSizesLoader;
